import React, { ComponentPropsWithoutRef, ReactNode } from 'react';
import {
  LozengeColor,
  LozengeIcon,
  LozengeSize,
  LozengeVariant,
  StyledLozenge,
} from './Lozenge.styles';
import { RawButton } from '../Button/Button.styles';
import { MarginProps } from '../../../theme/styledProps';
import { Box } from '../Box/Box';

export interface Props extends MarginProps, ComponentPropsWithoutRef<'div'> {
  /**
   * Note: When the variant is 'dot' the icon prop will not have any effect
   */
  variant?: LozengeVariant;
  variantColor?: LozengeColor;
  size?: LozengeSize;
  /**
   * Use font-awesome classes to render icons (e.g. fas fa-home). The icon is rendered on the text's left-hand side.
   */
  icon?: string;
  /**
   * Use it to give the Lozenge an alternative appearance
   */
  isAlt?: boolean;
  /**
   * When defined, an 'x' button will be rendered and this function will be called by clicking on it.
   */
  onRequestClose?(): void;
  children?: ReactNode;
}

/**
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 */
export const Lozenge: React.FC<Props> = ({
  variant = 'default',
  variantColor = 'default',
  size = 'small',
  isAlt = false,
  icon,
  onRequestClose,
  children,
  ...rest
}) => {
  return (
    <StyledLozenge
      variant={variant}
      variantColor={variantColor}
      size={size}
      isAlt={isAlt}
      {...rest}
    >
      {icon && variant !== 'dot' && (
        <LozengeIcon
          className={icon}
          variantColor={variantColor}
          isAlt={isAlt}
          size={size}
          mr="4"
        />
      )}

      {children}

      {!!onRequestClose && (
        <Box ml="8">
          <RawButton onClick={onRequestClose}>
            <LozengeIcon
              className="far fa-times"
              variantColor={variantColor}
              isAlt={isAlt}
              size={size}
            />
          </RawButton>
        </Box>
      )}
    </StyledLozenge>
  );
};
